import template from './changePassword.html';
import controller from './changePassword.controller';

let changePassword = {
  restrict: 'E',
  bindings: {
      modelDetails: '=',
      onConfirm: '=',
      onError: '=',
      event: '='
  },
  template,
  controller
};

export default changePassword;



// WEBPACK FOOTER //
// ./client/app/common/ui/changePassword/changePassword.component.js